import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';



const RewardsCatalog = () => {
  const [rewards, setRewards] = useState([]);

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    // Mock data
    const mockRewards = [
      {
        id: 1,
        name: 'Free Guest Pass',
        pointsCost: 500,
        category: 'guest',
        stock: 'Unlimited',
        redemptions: 89,
        active: true
      },
      {
        id: 2,
        name: 'Personal Training Session',
        pointsCost: 1500,
        category: 'training',
        stock: 12,
        redemptions: 45,
        active: true
      },
      {
        id: 3,
        name: 'Massage Therapy',
        pointsCost: 3000,
        category: 'wellness',
        stock: 5,
        redemptions: 23,
        active: true
      }
    ];
    setRewards(mockRewards);
  };

  return (
    <div className="space-y-6">
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl font-heading font-semibold text-foreground mb-1">
              Rewards Catalog Management
            </h2>
            <p className="text-sm text-muted-foreground">
              Manage redeemable rewards and track inventory
            </p>
          </div>
          <Button iconName="Plus">
            Add Reward
          </Button>
        </div>

        <div className="space-y-3">
          {rewards?.map((reward) => (
            <div
              key={reward?.id}
              className="p-4 rounded-lg border border-border hover:border-border/60 transition-colors"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <h3 className="font-semibold text-foreground mb-2">{reward?.name}</h3>
                  <div className="flex items-center gap-4 text-sm">
                    <div className="flex items-center gap-1">
                      <Icon name="Coins" size={14} color="var(--color-primary)" />
                      <span className="text-primary font-medium">
                        {reward?.pointsCost?.toLocaleString()} pts
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Package" size={14} color="var(--color-muted-foreground)" />
                      <span className="text-muted-foreground">
                        Stock: {reward?.stock}
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="ShoppingCart" size={14} color="var(--color-success)" />
                      <span className="text-success font-medium">
                        {reward?.redemptions} redeemed
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Button variant="outline" size="sm" iconName="Edit">
                    Edit
                  </Button>
                  <Button
                    variant={reward?.active ? 'success' : 'outline'}
                    size="sm"
                    iconName={reward?.active ? 'Eye' : 'EyeOff'}
                  >
                    {reward?.active ? 'Active' : 'Inactive'}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fulfillment Tracking */}
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Fulfillment Tracking
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 rounded-lg bg-warning/10 border border-warning/30">
            <div className="flex items-center gap-3 mb-2">
              <Icon name="Clock" size={20} color="var(--color-warning)" />
              <span className="font-semibold text-foreground">Pending</span>
            </div>
            <p className="text-2xl font-heading font-bold text-foreground">12</p>
            <p className="text-xs text-muted-foreground">Awaiting fulfillment</p>
          </div>
          <div className="p-4 rounded-lg bg-primary/10 border border-primary/30">
            <div className="flex items-center gap-3 mb-2">
              <Icon name="Truck" size={20} color="var(--color-primary)" />
              <span className="font-semibold text-foreground">In Progress</span>
            </div>
            <p className="text-2xl font-heading font-bold text-foreground">8</p>
            <p className="text-xs text-muted-foreground">Being processed</p>
          </div>
          <div className="p-4 rounded-lg bg-success/10 border border-success/30">
            <div className="flex items-center gap-3 mb-2">
              <Icon name="CheckCircle" size={20} color="var(--color-success)" />
              <span className="font-semibold text-foreground">Completed</span>
            </div>
            <p className="text-2xl font-heading font-bold text-foreground">156</p>
            <p className="text-xs text-muted-foreground">This month</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardsCatalog;